export default {
    home_page_title: "Данные аккаунта",
    security_page_title: "Центр безопасности",
    security_setting_page_title: "Центр безопасности",
    security_phone_label: "Моб. тел.",
    security_email_label: "Эл. почта",
    security_question_label: "Вопрос безопасности",
    security_unset_text: "Не установлен",
    security_setted_text: "Настроено",
    security_question_options: [
        "Имя Вашей матери?",
        "День рождения супруги/супруга?",
        "Имя Вашего отца?",
        "Номер Вашего студенческого (или трудовой книжки)?",
        "Имя Вашего лучшего друга детства?",
        "Имя великого человека, произведшего на Вас наиболее сильное впечатление?"
    ],
    password_lost_page_title: "Забыли пароль?",
    password_reset_page_title: "Сбросить пароль",
    password_lost_account_placeholder: "Введите аккаунт забытого пароля",
    empty_lost_account_tips: "Имя пользователя не должно быть пустым",
    iscorrect_lost_account_tips: "Пользователь не существует",
    password_reset_new_placeholder: "Новый пароль",
    password_reset_confirm_placeholder: "Подтвердите новый пароль",
    password_verify_page_title: "Верификация личности",
    phone_verify_page_title: "Верификация личности",
    email_verify_page_title: "Верификация личности",
    question_verify_page_title: "Верификация личности",
    phone_reset_page_title: "Моб. тел.",
    email_reset_page_title: "Эл. почта",
    question_reset_page_title: "Вопрос безопасности",
    phone_binding_text: "Ваш связанный номер телефона",
    email_binding_text: "Ваша связанная эл. почта",
    verification_code_text: "Проверочный код",
    resend_text: "Отправить заново",
    empty_phone_number_tips: "Введите номер тел.",
    iscorrect_phone_number_tips: "Введите правильный формат моб. тел.",
    empty_verification_code_tips: "Введите проверочный код",
    iscorrect_verification_code_tips: "Неверный проверочный код",
    password_placeholder: "Пароль",
    empty_password_tips: "Введите пароль",
    iscorrect_password_tips: "Неверный пароль",
    mismatched_rule_password_tips: "Пароль не должен содержать &, #, пробелы",
    different_confirm_password_tips: "Пароли не совпадают",
    empty_email_tips: "Пожалуйста, введите эл. почту",
    iscorrect_email_tips: "Неверная эл. почта",
    answer_placeholder: "Ответ",
    empty_question_tips: "Секретный вопрос",
    empty_answer_tips: "Ответ",
    iscorrect_answer_tips: "Неверный ответ",
    next_step_text: "Следующий",
    submit_text: "Отправить",
    submit_success_tips: "Настроено",
    submit_error_tips: "Операция не удалась, попробуйте еще раз",
    get_data_fail_tips: "Произошла ошибка в сети, попробуйте еще раз",
    use_other_verification_type_text: "Верификация другим способом",
    custom_support_notice:
        "На данном аккаунте не настроена защита паролем, вы можете открыть следующую ссылку через клиент PC, чтобы отправить жалобу:" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
